<div class="flex flex-col gap-4 my-life-acts-menu h-full">
  <div *ngFor="let level of menu">
    <pl-life-acts-menu-item
      class="pr-6"
      [chevronDirection]="level.isExpanded ? ChevronDirection.up : ChevronDirection.down"
      [isDisabled]="level.isDisabled"
      [isSelected]="level | isMenuItemSelected: currentlySelectedLifeactStepFullUrl"
      [status]="level.status"
      [title]="level.title"
      (menuItemClicked)="onLevelClicked(level)"
    />
    <mat-expansion-panel [(expanded)]="level.isExpanded" class="rounded-0 !shadow-none">
      <div class="flex flex-col gap-4 pt-4">
        <pl-life-acts-menu-item
          *ngFor="let module of level.modules"
          [chevronDirection]="ChevronDirection.right"
          [isDisabled]="module.isDisabled"
          [isSelected]="module | isMenuItemSelected: currentlySelectedLifeactStepFullUrl"
          [status]="module.statusLifeActStep"
          [title]="module.title"
          (menuItemClicked)="onModuleClicked(module)"
        />
      </div>
    </mat-expansion-panel>
  </div>
</div>
